import React from 'react';
import { Message, MessageProps } from '../Message/Message';

/**
 *
 * Component for user message
 * @usage <UserMessage
 * text = 'lorem ipsum'
 * icon = 'path to logo'
 * />
 */
const UserMessage = ({ ...props }: MessageProps): JSX.Element => {
  return <Message messageType="user" text={props.text} />;
};

export { UserMessage };
